import request from '@/utils/request';
import ENVIRONMENT from '@/utils/environment';
import { getToken } from '@/utils/auth';

// 查询分页列表(系统通知信息)
export function getRemindersList(options) {
  return request({
    url: '/device/upgrade/reminders/page',
    method: 'get',
    params: options
  });
}
// 发送提醒
export function sendReminders(options) {
  return request({
    url: '/device/upgrade/reminders/send',
    method: 'post',
    params: options
  });
}
// 查询分页列表(手动通知信息)
export function getRemindersManualList(options) {
  return request({
    url: '/device/upgrade/reminders/manual/page',
    method: 'get',
    params: options
  });
}
// 获取资源导入
export function getUpgradeRemindersManualImport() {
  return `${ENVIRONMENT.BASE_API}/device/upgrade/reminders/manual/import`;
}
// 获取资源模板
export function getUpgradeRemindersTemplateExport() {
  return `${ENVIRONMENT.BASE_API}/device/upgrade/reminders/template/download?token=${getToken()}`;
}
// 手动提醒发送通知
export function sendRemindersManual(options) {
  return request({
    url: '/device/upgrade/reminders/manual/resend',
    method: 'get',
    params: options
  });
}
